import HomePageBlock from './homePageBlock';
export default HomePageBlock